"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("@tanstack/react-query");
var _auth = require("../../packages/auth");
var _userVehicle = require("../../services/user-vehicle");
const useRawUserVehicles = function (options) {
  const isAuthenticated = (0, _auth.useIsAuthenticated)();
  const service = (0, _userVehicle.useReadUserVehicleService)();
  const query = (0, _reactQuery.useQuery)({
    enabled: isAuthenticated,
    queryFn: async function (_ref) {
      let {
        signal
      } = _ref;
      const {
        data
      } = await service.find({
        signal
      });
      return data;
    },
    queryKey: ["user-vehicles", isAuthenticated],
    ...options
  });
  return {
    ...query,
    isLoading: query.isLoading && query.fetchStatus !== "idle"
  };
};
var _default = exports.default = useRawUserVehicles;